import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-08fd734d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "travel_order_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "预定人信息", -1));

const _hoisted_7 = {
  class: "base_details_content_second"
};
const _hoisted_8 = {
  key: 0,
  class: "base_details_title"
};
const _hoisted_9 = {
  key: 1,
  class: "base_details_content_second"
};
const _hoisted_10 = {
  key: 2,
  class: "base_details_title"
};
const _hoisted_11 = {
  key: 3,
  class: "base_details_content_second"
};
const _hoisted_12 = {
  style: {
    "white-space": "pre-line",
    "color": "#606266"
  }
};
const _hoisted_13 = {
  key: 4,
  class: "base_details_title"
};
const _hoisted_14 = {
  key: 5,
  class: "base_details_content_second"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "产品信息", -1));

const _hoisted_16 = {
  class: "base_details_content_second"
};
const _hoisted_17 = ["src"];

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "附加费用", -1));

const _hoisted_19 = {
  class: "base_details_content_second"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠信息", -1));

const _hoisted_21 = {
  class: "base_details_content_second"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  key: 2
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1));

const _hoisted_26 = {
  key: 6,
  class: "base_details_title"
};
const _hoisted_27 = {
  key: 7,
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref, reactive } from 'vue';
import { $msg, $box } from "@ui/msg";
import useRoute from "@util/router";
import OrderShipments from "@com/order/OrderShipments.vue";
import CancelOrder from "@com/order/CancelOrder.vue";
import CancelAfterSale from "@com/order/CancelAfterSale.vue";
import ConfirmAfterSale from "@com/order/ConfirmAfterSale.vue";
import $ from "@util/base";
import api from "@api/order";
import afterApi from "@api/afterSaleOrder";
export default {
  __name: 'TravelOrderDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const typeKey = urlQuery.type;
    var readOnly = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
      }
    });
    const data = ref({
      orderItem: {},
      // 订单信息
      guestItemList: [{}],
      // 预订人信息
      addressItem: {},
      // 收货人信息
      packageList: [],
      // 套餐列表(产品信息)
      promotionList: [],
      // 优惠列表
      groupItem: {},
      // 拼团信息
      afterSaleItem: {} // 售后信息

    });
    const expenseAftersale = ref(null);
    const refundMoney = ref(null);
    const depositMoney = ref(null);
    getData();

    function getData() {
      api.detail("travel", urlQuery.code, urlQuery.afterSaleCode, val => {
        if ($.isNotEmpty(val.afterSaleItems)) {
          val.afterSaleItem = val.afterSaleItems[0];
          refundMoney.value = val.afterSaleItem.refundMoney;
          depositMoney.value = val.afterSaleItem.depositMoney;
        }

        expenseAftersale.value = val.orderItem.expenseAftersale;

        if (val != null && val.guestItemList != null && val.guestItemList.length > 0) {
          val.guestItemList.map(e => {
            if (e.sharedRoomFlag == 1) {
              e.sharedRoom = "是";
            } else {
              e.sharedRoom = "否";
            }

            return e;
          });
        }

        data.value = val;
        getConfig(val.orderItem.orderStatus);
      });
    }

    let statusTitle = ref("已完成"); // 1022001 未付款、1022002 处理中、1022003 已取消、1022004 未出行、1022005 已完成

    function getConfig(status) {
      switch (status) {
        case "1022001":
          statusTitle.value = "未付款";
          break;

        case "1022002":
          statusTitle.value = "处理中";
          break;

        case "1022003":
          statusTitle.value = "已取消";
          break;

        case "1022004":
          statusTitle.value = "未出行";
          break;

        case "1022005":
          statusTitle.value = "已完成";
          break;
      }
    } // function acceptOrder() {
    //   $box.open("二次已确认", "是否二次已确认？", () => {
    //     api.confirm('travel', urlQuery.code, () => {
    //       $msg.succ("二次已确认成功");
    //       getData()
    //     })
    //   }, (msg) => {
    // $box.open("二次已确认失败", msg)
    //   });
    // }


    const cancelOrderRef = ref("");

    function cancelOrder() {
      cancelOrderRef.value.show();
    }

    function getCancelOrder(data) {
      api.cancel({
        type: "travel",
        code: urlQuery.code,
        // amount: data.amount,
        remark: data.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    const shipmentsRef = ref("");

    function shipments() {
      shipmentsRef.value.show();
    }

    function getShipments(data) {
      api.shipment("travel", {
        orderCode: urlQuery.code,
        expressDetail: data.express // expressName: data.company,
        // expressNo: data.number

      }, () => {
        $msg.succ("发货成功");
        getData();
      });
    }

    function confirmAfterSale() {
      confirmAfterSaleRef.value.show();
    }

    function confirmAfterSaleSubmit(money, deposit) {
      afterApi.confirm(data.value.afterSaleItem.afterSaleCode, money, deposit, () => {
        $msg.succ("退款成功");
        getData();
      });
    }

    const cancelAfterSaleRef = ref(null);
    const confirmAfterSaleRef = ref(null);

    function cancelAfterSale() {
      cancelAfterSaleRef.value.show();
    }

    function getCancelAfterSale(data) {
      afterApi.cancel({
        afterSaleCode: data.value.afterSaleItem.afterSaleCode,
        remark: data.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    function confirmTakeOver() {
      $box.alert("确认收货", `<div>确定已收到退货商品？</div><div>${data.value.afterSaleItem.expressName}：${data.value.afterSaleItem.expressNo}</div>`, () => {
        afterApi.takeOver(data.value.afterSaleItem.afterSaleCode, () => {
          $msg.succ("确定收货成功");
          getData();
        });
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      const _component_el_descriptions = _resolveComponent("el-descriptions");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_unref(typeKey) === 'after' ? (_openBlock(), _createBlock(BackTitleView, {
          key: 0,
          title: `售后详情-${data.value.afterSaleItem.afterSaleStatusName}`
        }, null, 8, ["title"])) : (_openBlock(), _createBlock(BackTitleView, {
          key: 1,
          title: `订单详情-${data.value.orderItem.orderStatusStr}`
        }, null, 8, ["title"])), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "订单编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.orderCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "归属基地："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.shopName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "下单时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.createTime), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "付款时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.payTime), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "活动优惠："
            }, {
              default: _withCtx(() => [_createTextVNode("-¥" + _toDisplayString(data.value.orderItem.discountMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "储值支付："
            }, {
              default: _withCtx(() => [_createTextVNode("-¥" + _toDisplayString(data.value.orderItem.depositMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "积分兑换："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.integral), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "实付金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.orderItem.dueMoney), 1)]),
              _: 1
            }), data.value.orderItem.agentMemberName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "分销员："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.agentMemberName), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "出行日期："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.travelDate), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_table, {
            data: data.value.guestItemList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "联系电话",
              prop: "phoneNumber",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "预订人",
              prop: "guestName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "英文名",
              prop: "englishName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "证件照",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(scope => [scope.row.idCardPhoto1 ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                previewSrcList: [scope.row.idCardPhoto1],
                src: scope.row.idCardPhoto1,
                style: {
                  "width": "75px",
                  "height": "75px"
                }
              }, null, 8, ["previewSrcList", "src"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "身份证",
              prop: "identityCardNumber",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "拼房人",
              prop: "sharedRoom",
              align: "center"
            })]),
            _: 1
          }, 8, ["data"])]), data.value.addressItem.recipientName ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 收货人信息 ")) : _createCommentVNode("", true), data.value.addressItem.recipientName ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "收货人："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.addressItem.recipientName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "联系电话："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.addressItem.phoneNumber), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "收货地址："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.addressItem.addressFull), 1)]),
              _: 1
            })]),
            _: 1
          })])) : _createCommentVNode("", true), data.value.express ? (_openBlock(), _createElementBlock("div", _hoisted_10, "发货信息")) : _createCommentVNode("", true), data.value.express ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(data.value.express.expressDetail), 1)])) : _createCommentVNode("", true), _unref(statusTitle) == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 取消原因 ")) : _createCommentVNode("", true), _unref(statusTitle) == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(data.value.orderItem.cancelReason), 1)) : _createCommentVNode("", true), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_table, {
            data: data.value.packageList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "产品图片",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("img", {
                src: scope.row.mainPic,
                style: {
                  width: '75px',
                  height: '75px'
                }
              }, null, 8, _hoisted_17)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "产品名称",
              prop: "travelName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "套餐名称",
              prop: "packageName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "产品编码",
              prop: "travelCode",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "价格",
              prop: "duePrice",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "购买数量",
              prop: "sellNum",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "小计",
              prop: "totalDuePrice",
              align: "center"
            })]),
            _: 1
          }, 8, ["data"])]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.extraExpenseList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_descriptions_item, {
                key: index,
                label: `${item.extraName}：`
              }, {
                default: _withCtx(() => [_createTextVNode(" ¥" + _toDisplayString(item.extraPrice), 1)]),
                _: 2
              }, 1032, ["label"]);
            }), 128))]),
            _: 1
          })]), _hoisted_20, _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_table, {
            data: data.value.promotionList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "优惠名称",
              prop: "promotionName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "优惠金额",
              prop: "promotionMoney",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "优惠类型",
              align: "center"
            }, {
              default: _withCtx(scope => [scope.row.promotionType == '1020001' ? (_openBlock(), _createElementBlock("span", _hoisted_22, "优惠券")) : scope.row.promotionType == '1020002' ? (_openBlock(), _createElementBlock("span", _hoisted_23, "综合活动兑换")) : scope.row.promotionType == '1020003' ? (_openBlock(), _createElementBlock("span", _hoisted_24, "优惠活动")) : _createCommentVNode("", true), _hoisted_25]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]), _unref(typeKey) === 'after' ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 售后信息 ")) : _createCommentVNode("", true), _unref(typeKey) === 'after' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "售后编码："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "订单业务类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.mainBusiTypeName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleTypeName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后状态："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleStatusName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后原因类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.reasonType), 1)]),
              _: 1
            }), data.value.afterSaleItem.reasonDesc ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "售后原因详情："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.reasonDesc), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "会员编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.memberCode), 1)]),
              _: 1
            }), data.value.afterSaleItem.cancelInfo ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 1,
              label: "售后取消原因："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.cancelInfo), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "退款金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.afterSaleItem.refundMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "退还储值金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.afterSaleItem.depositMoney), 1)]),
              _: 1
            }), data.value.afterSaleItem.expressName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 2,
              label: "退回快递公司："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.expressName), 1)]),
              _: 1
            })) : _createCommentVNode("", true), data.value.afterSaleItem.expressNo ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 3,
              label: "退回快递单号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.expressNo), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "创建时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.createTime), 1)]),
              _: 1
            }), data.value.afterSaleItem.updateTime ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 4,
              label: "更新时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.updateTime), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })])) : _createCommentVNode("", true)])])]),
          _: 1
        }), _unref(typeKey) === 'after' ? (_openBlock(), _createBlock(_component_el_footer, {
          key: 2
        }, {
          default: _withCtx(() => [data.value.afterSaleItem.afterSaleStatus === '1052001' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: confirmAfterSale,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("确认退款 ")]),
            _: 1
          })) : _createCommentVNode("", true), data.value.afterSaleItem.afterSaleStatus === '1052001' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelAfterSale,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("取消售后 ")]),
            _: 1
          })) : _createCommentVNode("", true), data.value.afterSaleItem.afterSaleStatus === '1052005' || data.value.afterSaleItem.afterSaleStatus === '1052006' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: confirmTakeOver,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("确认收货 ")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_footer, {
          key: 3
        }, {
          default: _withCtx(() => [!_unref(readOnly) && data.value.orderItem.isDeliver == 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: shipments,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("发货")]),
            _: 1
          })) : _createCommentVNode("", true), !_unref(readOnly) && (_unref(statusTitle) == '未付款' || _unref(statusTitle) == '处理中') ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelOrder
          }, {
            default: _withCtx(() => [_createTextVNode("取消订单 ")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(OrderShipments, {
        ref_key: "shipmentsRef",
        ref: shipmentsRef,
        onShipments: getShipments
      }, null, 512), _createVNode(CancelOrder, {
        ref_key: "cancelOrderRef",
        ref: cancelOrderRef,
        onCancelOrder: getCancelOrder
      }, null, 512), _createVNode(CancelAfterSale, {
        ref_key: "cancelAfterSaleRef",
        ref: cancelAfterSaleRef,
        onCancelAfterSale: getCancelAfterSale
      }, null, 512), _createVNode(ConfirmAfterSale, {
        ref_key: "confirmAfterSaleRef",
        ref: confirmAfterSaleRef,
        desc: expenseAftersale.value,
        money: refundMoney.value,
        deposit: depositMoney.value,
        onSubmit: confirmAfterSaleSubmit
      }, null, 8, ["desc", "money", "deposit"])]);
    };
  }

};